import React from 'react';
import { Logo } from './Logo';
export const Footer = () => {
  return <footer className="bg-slate-800" data-id="element-58" data-mp="3gf93arl2hy6u">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-59" data-mp="3ggarlxr3gh6i">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-60" data-mp="32o4b2ak1486j">
          <div className="flex flex-col items-center md:items-start" data-id="element-61" data-mp="32pp3nums9h1r">
            <div className="bg-white p-4 rounded-lg inline-block" data-id="element-62" data-mp="36q9354utwwr2">
              <Logo isSmall={true} data-id="element-63" data-mp="3ufa6wespvjq0" />
            </div>
            <p className="mt-4 text-base text-slate-300 text-center md:text-left" data-id="element-64" data-mp="3uftlpmn2lrzt">
              Cultivating wealth for generations through strategic investment
              management.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-start" data-id="element-65" data-mp="3lgoocjn8w4p8">
            <h3 className="text-sm font-semibold text-slate-300 tracking-wider uppercase" data-id="element-66" data-mp="3qbvojhhb2r9e">
              Navigation
            </h3>
            <div className="mt-4 space-y-2" data-id="element-67" data-mp="2a1jhr4jztm0c">
              <a href="#about" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-68" data-mp="2ezb9nykn184j">
                About
              </a>
              <br data-id="element-69" data-mp="3gaz2f4jbankm" />
              <a href="#services" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-70" data-mp="3gbilwpom1k0r">
                Services
              </a>
              <br data-id="element-71" data-mp="3q83q58st2r3j" />
              <a href="#performance" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-72" data-mp="3q7u1bojhypzf">
                Performance
              </a>
              <br data-id="element-73" data-mp="32w1fp6mx48o" />
              <a href="#team" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-74" data-mp="33e71cf6sut9">
                Team
              </a>
              <br data-id="element-75" data-mp="ctgxb4uxbunw" />
              <a href="#contact" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-76" data-mp="cv1uz3cjbtpz">
                Contact
              </a>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-start" data-id="element-77" data-mp="mtrcgv0irc5p">
            <h3 className="text-sm font-semibold text-slate-300 tracking-wider uppercase" data-id="element-78" data-mp="tw5w602sbejk">
              Legal
            </h3>
            <div className="mt-4 space-y-2" data-id="element-79" data-mp="yuh8qikgs35h">
              <a href="#" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-80" data-mp="13sr3is2a11qk">
                Privacy Policy
              </a>
              <br data-id="element-81" data-mp="1clmcnwuv7hlm" />
              <a href="#" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-82" data-mp="1cm448g6l17n7">
                Terms of Service
              </a>
              <br data-id="element-83" data-mp="1mjsao3djw3l7" />
              <a href="#" className="text-base text-slate-400 hover:text-[#D4AF37]" data-id="element-84" data-mp="1mj8qeg0fh340">
                Disclaimer
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-slate-700 pt-8" data-id="element-85" data-mp="3ocgiyr51xh7u">
          <p className="text-base text-slate-400 text-center" data-id="element-86" data-mp="3t9yg7k9pi800">
            © {new Date().getFullYear()} Aurum Grove Capital. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};